import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'

import { withProcedureWraper } from '..'
import { Routes } from '../../../AppRoutes'
import { Box } from '../../../components/box'
import { Icon } from '../../../components/icon'
import { Table } from '../../../modules/table'
import { useSelector } from '../../../store/store'
import { ITCodeRequestService } from '../../../services/it-code-request/itCodeRequest.service'
import { getDDMMYYYFormat } from '../../../helper/dateTimeHelper'
import { approverType, itCodeRequestTypes } from '../../../constants/itCodeRequestConstants'
import { requestStatus } from '../../../constants/statusConstants'

export const ITCodeGrantedApprovalHistoryPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const user = useSelector(state => state.user);
  const currentUserName = user?.current?.username;
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);

  const getITCodeRequests = () => {
    return ITCodeRequestService.getITCodeRequestsApprovalHistory(currentUserName).then(res => {
      return { data: res.reverse(), count: res.length }
    }, () => {
      return { data: [], count: 0 }
    });
  }

  const getStatusBaseOnApprover = (item: any) => {
    const { eApprovedBy, eApprovedByITLead, eApprovedByITHead, eAssignee, eRequestStatus } = item;
    if (!eRequestStatus) {
      const approverEmail = eApprovedBy ? eApprovedBy.split('|')[1] : '';
      const approvedByITLeadEmail = eApprovedByITLead ? eApprovedByITLead.split('|')[1] : '';
      const approvedByITHeadEmail = eApprovedByITHead ? eApprovedByITHead.split('|')[1] : '';
      const assigneeEmail = eAssignee ? eAssignee.split('|')[1] : '';
      if (currentUserName.toLowerCase() === approverEmail.toLowerCase()) {
        return item.eApprovedStatus || requestStatus.submitted;
      } else if (currentUserName.toLowerCase() === approvedByITLeadEmail.toLowerCase()) {
        return item.eApprovedByITLeadStatus || requestStatus.submitted;
      } else if (currentUserName.toLowerCase() === approvedByITHeadEmail.toLowerCase()) {
        return item.eApprovedByITHeadStatus || requestStatus.submitted;
      } else if (currentUserName.toLowerCase() === assigneeEmail.toLowerCase()) {
        return item.eAssigneeStatus || requestStatus.submitted;
      }
    } else {
      return eRequestStatus;
    }
  }

  const getStepBaseOnApprover = (item: any) => {
    const { eApprovedBy, eApprovedByITLead, eApprovedByITHead, eAssignee } = item;
    const approverEmail = eApprovedBy ? eApprovedBy.split('|')[1] : '';
    const approvedByITLeadEmail = eApprovedByITLead ? eApprovedByITLead.split('|')[1] : '';
    const approvedByITHeadEmail = eApprovedByITHead ? eApprovedByITHead.split('|')[1] : '';
    const assigneeEmail = eAssignee ? eAssignee.split('|')[1] : '';
    if (currentUserName.toLowerCase() === approverEmail.toLowerCase()) {
      return approverType.approver;
    } else if (currentUserName.toLowerCase() === approvedByITLeadEmail.toLowerCase()) {
      return approverType.itlead;
    } else if (currentUserName.toLowerCase() === approvedByITHeadEmail.toLowerCase()) {
      return approverType.ithead;
    } else if (currentUserName.toLowerCase() === assigneeEmail.toLowerCase()) {
      return approverType.assignee;
    }
  }

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureItCodeGranted.path)}>
              <Icon.ArrowLeft />
            </div>
            {'Yêu cầu cấp code'}
          </div>
        </div>
        <Box title="Quản lí yêu cầu cung cấp code">
          <Table
            onRowClick={(item) => history.push(Routes.procedureItCodeGrantedDetail.path.replace(':id', item.id))}
            structure={[
              {
                name: 'Ngày tạo',
                render: (item) => getDDMMYYYFormat(item.createdDateTime)
              },
              {
                name: 'Nhân viên',
                render: (item) => {
                  return `${item.createdBy.user.displayName}`
                }
              },
              {
                name: 'Yêu cầu',
                render: (item) => <>
                  <span className="flag success">
                    {itCodeRequestTypes && itCodeRequestTypes.find(o => o.value === item.fields.eRequestType)?.label}
                  </span>
                </>
              },
              {
                name: 'Phần mềm',
                render: (item) => {
                  const data = softwares.find((v: any) => v.id === item.fields.eSoftwareId);
                  return data && data.Title;
                }
              },
              {
                name: 'Mô tả',
                render: (item) => item.fields.eDescription
              },
              {
                name: 'Trạng thái',
                render: (item) => {
                  const status = getStatusBaseOnApprover(item.fields);
                  const step = getStepBaseOnApprover(item.fields);
                  if (status === requestStatus.submitted) return <span className="flag warning">
                    {step === approverType.assignee ? 'Đang đợi thực thi' : 'Đang đợi duyệt'}
                  </span>

                  if (status === requestStatus.approved) return <span className="flag success">
                    {'Đã duyệt'}
                  </span>

                  if (status === requestStatus.inProgress) return <span className="flag info">
                    {'Đang thực thi'}
                  </span>

                  if (status === requestStatus.rejected) return <span className="flag danger">
                    {'Đã từ chối'}
                  </span>

                  if (status === requestStatus.completed) return <span className="flag success">
                    {`Đã ${itCodeRequestTypes.find(o => o.value === item.fields.eRequestType)?.label}`}
                  </span>
                }
              }
            ]}
            onFetchData={getITCodeRequests}
          />
        </Box>
      </div>
    </div>
  )
})